import { useSite } from "@/context/SiteContext";

export default function FinalCta({ title = ["Let's get you", "a quote."], service = "commercial", context = "Quote request" }) {
  const { openLead } = useSite();
  return (
    <div className="wrap">
      <section className="final" data-testid="final-cta">
        <div>
          <span className="eyebrow">WE INSTALL COMMERCIAL SOLAR</span>
          <h2>
            {title[0]}
            <br />
            {title[1]}
          </h2>
          <p>Send your details — or upload a recent bill — and get a quote built around your property.</p>
        </div>
        <button className="btn" data-testid="final-cta-button" onClick={() => openLead(service, context)}>
          Get my quote <span>↗</span>
        </button>
      </section>
    </div>
  );
}
